import { PspPartnerPaymentType } from '../../types';

const getPspPartnerPaymentType = (type: string) => {
  let typeName;

  switch (type) {
    case PspPartnerPaymentType.BACS:
      typeName = 'BACS';
      break;
    case PspPartnerPaymentType.FASTER_PAYMENT:
      typeName = 'Faster payment';
      break;
    case PspPartnerPaymentType.SEPA_SCT:
      typeName = 'SEPA SCT';
      break;
    case PspPartnerPaymentType.SEPA_SCT_INST:
      typeName = 'SEPA SCT INST';
      break;
    case PspPartnerPaymentType.SWIFT:
      typeName = 'SWIFT';
      break;
    case PspPartnerPaymentType.TARGET_2:
      typeName = 'Target 2';
      break;
    case PspPartnerPaymentType.CRYPTO_ASSET_PAYMENT:
      typeName = 'Crypto Asset Payment';
      break;
    case PspPartnerPaymentType.FEDWIRE:
      typeName = 'Fedwire';
      break;
    case PspPartnerPaymentType.CASH_OVER_COUNTER:
      typeName = 'Cash Over Counter';
      break;
    default:
      typeName = type;
      break;
  }

  return typeName;
};

export default getPspPartnerPaymentType;
